import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { PermissionProvider } from './utils/PermissionContext';

import Login                from './components/Login';
import Layout               from './components/Layout';
import Setup2FA             from './components/Setup2FA';
import PendingRequests      from './components/PendingRequests';
import CompletedRequests    from './components/CompletedRequests';
import RejectedRequests     from './components/RejectedRequests';
import SiteSettings         from './components/SiteSettings';
import BonusManagement      from './components/BonusManagement';
import Dashboard            from './components/Dashboard';
import DomainSettings       from './components/DomainSettings';
import BlacklistSettings    from './components/BlackListSettings';
import CallMeBlackList      from './components/CallMeBlackList';
import FinansDashboard      from './components/FinansDashboard';
import KasaYonetimi         from './components/KasaYonetimi';
import GunlukHareketler     from './components/GunlukHareketler';
import OdemeYonetimi        from './components/OdemeYonetimi';
import TahsilatYonetimi     from './components/TahsilatYonetimi';
import VirmanYonetimi       from './components/VirmanYonetimi';
import OdemeYontemiYonetimi from './components/OdemeYontemiYonetimi';
import UserManagement       from './components/UserManagement';

/* Token kontrolü — her render'da localStorage'dan taze oku */
const TokenGuard = ({ children, fallback }) => {
  const token = localStorage.getItem('token');
  return token ? children : fallback;
};

const App = () => {
  /* tokenUpdated gelince App'i yeniden render et */
  const [, forceUpdate] = useState(0);

  useEffect(() => {
    const handler = () => forceUpdate(n => n + 1);
    window.addEventListener('tokenUpdated', handler);
    window.addEventListener('storage', handler);
    return () => {
      window.removeEventListener('tokenUpdated', handler);
      window.removeEventListener('storage', handler);
    };
  }, []);

  return (
    <Router>
      <PermissionProvider>
        <Routes>
          <Route path="/login"     element={<Login />} />
          <Route path="/setup-2fa" element={<Setup2FA />} />

          <Route
            path="/"
            element={
              <TokenGuard fallback={<Navigate to="/login" replace />}>
                <Layout />
              </TokenGuard>
            }
          >
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard"                element={<Dashboard />} />
            <Route path="pending-requests"         element={<PendingRequests />} />
            <Route path="completed-requests"       element={<CompletedRequests />} />
            <Route path="rejected-requests"        element={<RejectedRequests />} />
            <Route path="settings/bonuses"         element={<BonusManagement />} />
            <Route path="site-settings"            element={<SiteSettings />} />
            <Route path="domain-settings"          element={<DomainSettings />} />
            <Route path="blacklist-settings"       element={<BlacklistSettings />} />
            <Route path="callmeblacklist-settings" element={<CallMeBlackList />} />
            <Route path="financial-dashboard"      element={<FinansDashboard />} />
            <Route path="kasa-yonetimi"            element={<KasaYonetimi />} />
            <Route path="gunluk-hareketler"        element={<GunlukHareketler />} />
            <Route path="odeme-yonetimi"           element={<OdemeYonetimi />} />
            <Route path="tahsilat-yonetimi"        element={<TahsilatYonetimi />} />
            <Route path="virman-yonetimi"          element={<VirmanYonetimi />} />
            <Route path="odeme-yontemleri"         element={<OdemeYontemiYonetimi />} />
            <Route path="user-management"          element={<UserManagement />} />
          </Route>

          <Route path="*" element={
            <TokenGuard fallback={<Navigate to="/login" replace />}>
              <Navigate to="/dashboard" replace />
            </TokenGuard>
          } />
        </Routes>
      </PermissionProvider>
    </Router>
  );
};

export default App;